import webserviceClient from "@/api/webservice/webserviceClient";

export const backCallApi = {
    list: async (pageNum, name) => {
        return webserviceClient.get(`back-call?pageNum=${pageNum}&search=${name}`);
    }
}
